import React from 'react';
import SvgPhone from '../Icons/Phone';
import SvgEmail from '../Icons/Email';
import SvgGender from '../Icons/Gender';
import SvgLevel from '../Icons/Level';
import SvgForehand from '../Icons/Forehand';
import SvgRacketBrand from '../Icons/RacketBrand';

export default function UserInfo({
  user,
  showContact,
}: {
  user: Users.User;
  showContact: boolean;
}) {
  return (
    <div className="list-detail-contact">
      <div>
        <SvgPhone /> {user?.null_tel && showContact ? user.null_tel : '-'}
      </div>
      <div>
        <SvgEmail /> {user?.eposta && showContact ? user.eposta : '-'}
      </div>
      <div>
        <SvgGender />{' '}
        <span>{user?.cinsiyet === 0 ? 'Kadın' : user?.cinsiyet === 1 ? 'Erkek' : 'Çocuk'}</span>
      </div>
      <div>
        <SvgLevel /> {user?.null_seviye || '-'}
      </div>
      <div>
        <SvgForehand /> {user?.null_forehand || '-'}
      </div>
      <div>
        <SvgRacketBrand /> {user?.null_raket_marka || '-'}
      </div>
    </div>
  );
}
